export const fixed = (num) => {
    return Number(num).toFixed(2)
}